import React from 'react';

export default function NotificationWithBadgeIcon() {
  return (
    <svg width='22' height='22' viewBox='0 0 18.3 18.3' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M9.142 16.762C9.98 16.762 10.666 16.076 10.666 15.238H7.619C7.619 16.076 8.304 16.762 9.142 16.762ZM13.714 12.19V8.381C13.714 6.042 12.472 4.084 10.285 3.566V3.048C10.285 2.416 9.775 1.905 9.142 1.905C8.51 1.905 7.999 2.416 7.999 3.048V3.566C5.82 4.084 4.571 6.034 4.571 8.381V12.19L3.047 13.714V14.476H15.238V13.714L13.714 12.19ZM12.19 12.952H6.095V8.381C6.095 6.491 7.245 4.952 9.142 4.952C11.039 4.952 12.19 6.491 12.19 8.381V12.952Z'
        fill='#D97706'
      />

      <circle cx='13.8' cy='3.4' r='2.2' fill='#DA0808' />
    </svg>
  );
}
